import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, Params, PRIMARY_OUTLET } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AppService } from '../services/app.service';

interface IBreadcrumb {
  label: string;
  params: Params;
  url: string;
}
interface Breadcrumb {
  label: string;
  url: string;
}

//Breadcrumb exception list
const ExceptList: Breadcrumb[] = [
  { url: '/Home', label: '' },
  { url: '/Home/MyProfile', label: 'My Profile' }
]

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {
  @Input() parent: string;
  @Output() CurrentPath = new EventEmitter<string>();
  CurrentFullPath: string;
  Labels: string[];
  Menus: any[];
  Breads: Breadcrumb[] = [];
  CurrentMenu: any;

  constructor(private activatedRoute: ActivatedRoute, private appService: AppService,
    private router: Router) {
  }

  ngOnInit() {
    this.CurrentMenu = this.appService.currentMenu.subscribe(menu => {
      this.Menus = menu;
      if (this.Menus) {
        this.getBreads();
      }
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event) => {
      let root: ActivatedRoute = this.activatedRoute.root;
      if (this.Menus) {
        this.getBreads();
      }
    });
  }


  ngOnDestroy() {
    this.CurrentMenu.unsubscribe();
  }


  initBread() {
    let root: ActivatedRoute = this.activatedRoute.root;
    let bread = this.getBreadcrumbs(root);
    if (bread) {
      this.parent = bread.length > 0 ? bread[0].label : '';
      if (this.parent.indexOf(' > ') >= 0) {
        this.Labels = this.parent.split(' > ');
      }
      else {
        this.Labels = [this.parent];
      }
    }
  }

  ChangeParentPath(Path: string) {
    this.CurrentPath.emit(Path);
  }
  //#region getBreadcrumbs
  /**
       * Returns array of IBreadcrumb objects that represent the breadcrumb
       *
       * @class DetailComponent
       * @method getBreadcrumbs
       * @param {ActivateRoute} route
       * @param {string} url
       * @param {IBreadcrumb[]} breadcrumbs
       */
  private getBreadcrumbs(route: ActivatedRoute, url: string = "", breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
    const ROUTE_DATA_BREADCRUMB = "breadcrumb";
    if (!this.Menus) {
      return breadcrumbs;
    }

    const children: ActivatedRoute[] = route.children;
    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      if (!this.isPrimaryOutlet(child)) {
        continue;
      }

      if (!this.hasBreadcrumbData(child, ROUTE_DATA_BREADCRUMB)) {
        return this.getBreadcrumbs(child, url, breadcrumbs);
      }

      const routeURL = this.getRouteUrl(child);
      const nextUrl = url + `/${routeURL}`;
      const label = this.formatBreadcrumbLabel(child);

      breadcrumbs.push({
        label: label,
        url: nextUrl
      });

      return this.getBreadcrumbs(child, nextUrl, breadcrumbs);
    }
    return breadcrumbs;
  }

  private isPrimaryOutlet(route: ActivatedRoute): boolean {
    return route.outlet === PRIMARY_OUTLET;
  }

  private hasBreadcrumbData(route: ActivatedRoute, key: string): boolean {
    return route.snapshot.data.hasOwnProperty(key);
  }

  private getRouteUrl(route: ActivatedRoute): string {
    return route.snapshot.url.map(segment => segment.path).join("/");
  }

  private formatBreadcrumbLabel(route: ActivatedRoute): string {
    const ROUTE_DATA_BREADCRUMB = "breadcrumb";
    let label = route.snapshot.data[ROUTE_DATA_BREADCRUMB];
    if (label && label.indexOf('{0}') >= 0 && route.snapshot.params) {
      const val = this.getParamReplacementValue(route.snapshot.params);
      label = label === '' ? label.replace('> {0}', val) : label.replace('{0}', val);
    }
    return label;
  }

  private getParamReplacementValue(params: Params): string {
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const element = params[key];
        return ['new', 'create'].includes(element.toLowerCase()) ? 'Create' : 'Edit';
      }
      break;
    }
    return '';
  }
  //#endregion

  private getBreads() {
    let root = this.activatedRoute.root;
    this.Breads = this.routeRecurcive(root);
  }

  private routeRecurcive(route: ActivatedRoute, url: string = "", breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
    if (this.Menus) {
      let children: ActivatedRoute[] = route.children;

      //return if there are no more children
      if (children.length === 0) {
        return breadcrumbs;
      }

      //iterate over each children
      for (let child of children) {
        //verify primary route
        if (child.outlet !== PRIMARY_OUTLET) {
          continue;
        }

        //get the route's URL segment
        let routeAry = child.snapshot.url.map(segment => segment.path).filter(obj => obj !== 'Create' && obj !== 'New');
        if (child.snapshot.params) {
          let params = child.snapshot.params;

          //remove params from routeAry
          for (const key in params) {
            if (params.hasOwnProperty(key)) {
              const element = params[key];
              routeAry = routeAry.filter(obj => obj !== element);
            }
            break;
          }
        }

        let routeURL: string = routeAry.join("/");
        //append route URL to URL
        url += `/${routeURL}`;

        let menu = this.Menus.filter(x => x.MenuLink === url);
        let label = menu.length > 0 ? menu[0].MenuTitle : '';

        //check has parent menu
        if (label !== "" && menu.length > 0) {
          let current = this.Menus.filter(x => x.MenuLink === url);
          if (current && current.length > 0) {
            let parent = this.Menus.filter(x => x.MenuId === current[0].MenuPid);
            if (parent && parent.length > 0) {
              //let InBreads = breadcrumbs.filter(x => x.label === parent[0].MenuTitle);
              let parentBread: Breadcrumb = {
                label: parent[0].MenuTitle,
                url: parent[0].MenuLink
              }
              breadcrumbs.push(parentBread);
            }
          }
        }

        if (label !== '') {
          //add breadcrumb
          let breadcrumb: Breadcrumb = {
            label: label,
            //params: child.snapshot.params,
            url: url
          };
          breadcrumbs.push(breadcrumb);
        }
        else if (url !== '/Home') {
          //check is in except list
          let except = ExceptList.filter(x => x.url === url);
          if (except && except.length > 0) {
            let exceptBread: Breadcrumb = {
              label: except[0].label,
              url: except[0].url
            }
            breadcrumbs.push(exceptBread);
            return breadcrumbs;
          }
        }
        //recursive
        return this.routeRecurcive(child, url, breadcrumbs);
      }
    }
  }
}
